import React, { useEffect, useState } from 'react';
import moment from 'moment';
import _ from 'lodash';
import Chart from 'react-apexcharts';
import classes from './revenueGrowth.module.scss';
import Api from '../../../../api/api';
import { useQuery } from '../../../../utils/hooks/useQuery';
import MonthPicker from '../../../_common/Form/DatePickers/MonthPicker/MonthPicker';
import Button from '../../../_common/Form/Buttons/Button';
import Loader from '../../../_common/Loader/Loader';

const chartTemplate = {
  options: {
    chart: {
      type: 'bar',
      toolbar: {
        tools: {
          download: true,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
        },
      },
    },

    legend: { show: false },

    dataLabels: { enabled: false },

    colors: ['#547EEE', '#E905E0'],

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        distributed: true,
      },
    },

    grid: {
      strokeDashArray: 2,
    },

    tooltip: {
      y: {},
    },

    xaxis: {
      categories: [],
      axisBorder: { show: false },
      axisTicks: { show: false },
    },

    yaxis: {
      labels: {
        formatter(val) {
          return new Intl.NumberFormat('en', {
            notation: 'compact',
          }).format(val);
        },
      },
    },
  },

  series: [
    {
      name: 'Revenue',
      data: [],
    },
  ],
};

const thisMonth = moment().format('YYYY-MM');

const RevenueGrowthVSLastMonth = () => {
  const { query, setQuery } = useQuery();

  const [date, setDate] = useState(
    query.date ? moment(query.date).format('YYYY-MM') : thisMonth,
  );

  const [chart, setChart] = useState(chartTemplate);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const { data } = await Api.getGrowthManufacturer(date);

      const newChart = _.cloneDeep(chartTemplate);

      newChart.options.xaxis.categories = [
        moment(data.previous.date).format('MMM YYYY'),
        moment(data.current.date).format('MMM YYYY'),
      ];

      newChart.options.tooltip = {
        y: {
          formatter(val, { dataPointIndex }) {
            return `$${new Intl.NumberFormat('en').format(val)}${dataPointIndex === 1
              ? ` (${data.percent.startsWith('-') ? '' : '+'}${data.percent})`
              : ''}`;
          },
        },
      };

      if (!+data.previous.revenue && !+data.current.revenue) {
        newChart.options.yaxis = {
          min: 0,
          max: 100,
          tickAmount: 4,
        };
      }

      newChart.series[0].data = [
        data.previous.revenue,
        data.current.revenue,
      ];

      setChart(newChart);
      setLoading(false);
    })();
  }, [date]);

  const changeDate = (d) => {
    setDate(d);

    setQuery({ date: d });
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.filters_wrapper}>
        <div className={classes.picker_wrapper}>
          <MonthPicker
            date={date}
            size="default"
            onChange={(m) => changeDate(m)}
            hideClearButton
          />
        </div>

        <div className={classes.btns_wrapper}>
          <Button
            title="Clear"
            clearButton
            onClick={() => changeDate(thisMonth)}
          />
        </div>
      </div>

      <div className={`${classes.chart_wrapper} revenue_growth`}>
        {loading ? (
          <Loader />
        )

          : (
            <Chart
              options={chart.options}
              series={chart.series}
              type="bar"
              width="100%"
              height={270}
            />
          )}
      </div>
    </div>
  );
};

export default RevenueGrowthVSLastMonth;
